import React, {useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import '../style/CarsInfoPageBlock.css';
import {useEffect} from 'react';

const CarsInfoPageBlock = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const {brand, brandId, model, modelId, year, yearId, price} = location.state || {};
// вверху компонента
    const [vehicleInfo, setVehicleInfo] = useState(null);
    const [showOwnerMismatchModal, setShowOwnerMismatchModal] = useState(false);


    const [step, setStep] = useState(0);
    const [selectedInsurance, setSelectedInsurance] = useState(null);
    const [selectedInsuranceId, setSelectedInsuranceId] = useState(null);
    const [selectedTariff, setSelectedTariff] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [confirmationCode, setConfirmationCode] = useState('');
    const [passportInfo, setPassportInfo] = useState(null);

    const [insuranceCompanies, setInsuranceCompanies] = useState([]);

    const fetchVehicleInfo = async () => {
        try {
            const techPassport = formData.techPassport.trim();
            // если у вас серия и номер в одном поле — разбиваем:
            const techPassportSeria = techPassport.slice(0, 3).toUpperCase();
            const techPassportNumber = techPassport.slice(3);

            const response = await fetch('http://localhost:8081/api/passport/get-vehicle-data', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'User-Agent': 'insomnia/11.2.0',
                    'Authorization': 'Basic Uk9BRF9BU1NJU1Q6MzU3OTEwMTg='
                },
                body: JSON.stringify({
                    techPassportSeria,
                    techPassportNumber,
                    govNumber: formData.carNumber.toUpperCase(),
                }),
            });

            if (!response.ok) throw new Error('Ошибка при получении данных авто');
            const result = await response.json();
            // сохраняем в стейт
            setVehicleInfo(result.data);
            // и переходим на следующий шаг
            setStep(prev => prev + 1);
        } catch (err) {
            console.error(err);
            alert('Не удалось получить данные автомобиля');
        }
    };


    useEffect(() => {
        const fetchInsuranceData = async () => {
            try {
                const response = await fetch('http://localhost:8082/api/insurance/insurance-and-tariff', {
                    method: 'GET',
                    headers: {
                        'User-Agent': 'insomnia/11.2.0',
                    },
                });

                if (!response.ok) throw new Error('Ошибка при получении страховых компаний');

                const data = await response.json();

                // Группировка по названию компании
                const grouped = data.reduce((acc, item) => {
                    const name = item.insuranceName;
                    const companyId = item.tariff.companyId;

                    if (!acc[name]) {
                        acc[name] = {
                            name,
                            id: companyId,
                            tariffs: {},
                        };
                    }

                    acc[name].tariffs[item.tariff.name] = {
                        id: item.tariff.id, // 👈 ID тарифа
                        price: `${item.tariff.percent}%`, // Используем percent, так как price отсутствует
                    };

                    return acc;
                }, {});

                setInsuranceCompanies(Object.values(grouped));
            } catch (err) {
                console.error('❌ Ошибка загрузки страховых компаний:', err);
            }
        };

        fetchInsuranceData();
    }, []);


    const [formData, setFormData] = useState({
        carNumber: '',
        techPassport: '',
        passportSeries: '',
        passportNumber: '',
        birthDate: '',
        applicantPhone: '',
    });


    const handleTariffSelection = (company, tariffName) => {
        const selectedTariff = company.tariffs[tariffName];
        setSelectedInsurance(company.name);
        setSelectedInsuranceId(company.id);
        setSelectedTariff({
            name: tariffName,
            amount: selectedTariff.price,
            id: selectedTariff.id,
        });
        setStep(1);
    };

    const handleNext = async () => {
        if (step === 1) {
            if (!formData.carNumber || !formData.techPassport) {
                alert('Заполните номер машины и техпаспорт!');
                return;
            }

            // 👉 Вызов API получения данных авто
            await fetchVehicleInfo();
            return;
        }
        if (step === 2 && !formData.ownerPassport) {
            alert('Введите паспорт владельца!');
            return;
        }
        if (step === 3) {
            if (!formData.applicantPhone) {
                alert('Введите номер телефона заявителя!');
                return;
            }

            // 👉 Вызов API создания пользователя перед показом модалки
            await createUser();

            setShowModal(true);
            return;
        }

        setStep(prev => prev + 1);
    };

    const handleBack = () => {
        if (step === 0) navigate('/');
        else setStep(prev => prev - 1);
    };


    const handleConfirmCode = async () => {
        try {
            const response = await fetch('http://localhost:8081/api/verification-codes/verify-code', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'User-Agent': 'insomnia/11.2.0',
                },
                body: JSON.stringify({
                    phone: formData.applicantPhone,
                    verifyCode: Number(confirmationCode),
                }),
            });

            const verified = await response.json();

            if (!response.ok) {
                alert('Ошибка сервера при верификации');
            } else if (verified === true) {
                localStorage.setItem('phoneNumber', formData.applicantPhone);
                localStorage.setItem('userId_createdAt', new Date().toISOString());

                setShowModal(false);
                setStep(4);

                const payload = {
                    brand, brandId, model, modelId, year, yearId, price,
                    insuranceCompany: selectedInsurance,
                    insuranceCompanyId: selectedInsuranceId,
                    tariff: selectedTariff?.name,
                    tariffId: selectedTariff?.id,
                    amount: selectedTariff?.amount,
                    carNumber: formData.carNumber,
                    techPassport: formData.techPassport,
                    passportSeries: formData.passportSeries,
                    passportNumber: formData.passportNumber,
                    birthDate: formData.birthDate,
                    applicantPhone: formData.applicantPhone,
                    passportInfo,
                };

                try {
                    const orderResponse = await fetch('http://localhost:8082/api/orders/create-order', {
                        method: 'POST',
                        headers: {'Content-Type': 'application/json'},
                        body: JSON.stringify(payload),
                    });
                    if (!orderResponse.ok) throw new Error('Ошибка при создании заказа');
                    console.log('✅ Заказ успешно создан');
                } catch (err) {
                    console.error('❌ Ошибка при создании заказа:', err);
                }

            } else {
                alert('❌ Код неверный');
                setTimeout(() => navigate('/'), 3000);
            }
        } catch (error) {
            alert('Сетевая ошибка');
            console.error('Ошибка при верификации:', error);
        }
    };


    const fetchPassportInfo = async () => {
        try {
            const response = await fetch('http://localhost:8081/api/passport/get-passport-data', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'User-Agent': 'insomnia/11.2.0',
                },
                body: JSON.stringify({
                    birthDate: formData.birthDate,
                    passportSeries: formData.passportSeries,
                    passportNumber: formData.passportNumber,
                }),
            });

            const result = await response.json();

            if (result.result === 0) {
                setPassportInfo(result);

                // 👇 Проверка на PINFL владельца
                if (vehicleInfo?.pinfl && result.pinfl && vehicleInfo.pinfl !== result.pinfl) {
                    // Несовпадение PINFL — показать модалку
                    setShowOwnerMismatchModal(true);
                } else {
                    // Совпадают — идем дальше
                    setStep(prev => prev + 1);
                }
            } else {
                alert('❌ Данные не найдены или некорректны.');
            }
        } catch (error) {
            console.error('Ошибка API:', error);
            alert('Ошибка при запросе к серверу.');
        }
    };


    const renderSummary = () => (
        <div className="summary-container">
            <div className="summary-column">
                {brand && <p><strong>Марка:</strong> {brand}</p>}
                {brand && <p><strong>Марка ID:</strong> {brandId}</p>}
                {model && <p><strong>Модель:</strong> {model}</p>}
                {model && <p><strong>Модель ID:</strong> {modelId}</p>}
                {year && <p><strong>Год:</strong> {year}</p>}
                {year && <p><strong>Год ID:</strong> {yearId}</p>}
                {price && <p><strong>Цена:</strong> {price} UZS</p>}
                {selectedInsurance && (
                    <>
                        <p><strong>Страховая компания:</strong> {selectedInsurance}</p>
                        <p><strong>Страховая компания ID:</strong> {selectedInsuranceId}</p>
                        <p><strong>Тариф:</strong> {selectedTariff?.name.toUpperCase()}</p>
                        <p><strong>Тариф ID:</strong> {selectedTariff?.id}</p>
                        <p><strong>Сумма:</strong> {selectedTariff?.amount}</p>
                    </>
                )}
                {formData.applicantPhone && <p><strong>Телефон заявителя:</strong> {formData.applicantPhone}</p>}
                {formData.passportSeries && formData.passportNumber && (
                    <p><strong>Паспорт:</strong> {formData.passportSeries}{formData.passportNumber}</p>
                )}
                {formData.birthDate && <p><strong>Дата рождения:</strong> {formData.birthDate}</p>}
            </div>

            <div className="vehicle-info-box">
                <h3>📄 Информация об автомобиле</h3>
                {vehicleInfo ? (
                    <>
                        <p><strong>VIN:</strong> {vehicleInfo.bodyNumber}</p>
                        <p><strong>Номер двигателя:</strong> {vehicleInfo.engineNumber}</p>
                        <p><strong>ID авто:</strong> {vehicleInfo.vehicleId}</p>
                        <p><strong>Госномер:</strong> {vehicleInfo.govNumber}</p>
                        <p><strong>Модель:</strong> {vehicleInfo.modelName}</p>
                        <p><strong>Марка:</strong> {vehicleInfo.markaName}</p>
                        <p><strong>Цвет:</strong> {vehicleInfo.vehicleColor}</p>
                        <p><strong>PINFL владельца:</strong> {vehicleInfo.pinfl}</p>
                        <p><strong>Владелец:</strong> {vehicleInfo.owner}</p>
                    </>
                ) : (
                    <p>Нет данных об автомобиле</p>
                )}
            </div>
        </div>
    );

    const renderInsuranceList = () => (
        <div className="insurance-list">
            <h3>📋 Доступные страховые фирмы</h3>
            {insuranceCompanies.map((company, idx) => (
                <div key={idx} className="insurance-item">
                    <strong>{company.name} (ID: {company.id})</strong>
                    {Object.entries(company.tariffs).map(([tariffName, tariffData]) => (
                        <div key={tariffName} className="tariff-option">
                <span>
                    {tariffName.toUpperCase()} (ID: {tariffData.id}) — 💸 {tariffData.price}
                </span>
                            <button onClick={() => handleTariffSelection(company, tariffName)}>Выбрать</button>
                        </div>
                    ))}
                </div>
            ))}

        </div>
    );

    const renderStepContent = () => {
        switch (step) {
            case 0:
                return (
                    <>
                        <h2>🚗 Информация о выбранном авто</h2>
                        <div className="info-block">
                            <p><strong>Марка:</strong> {brand}</p>
                            <p><strong>Марка ID:</strong> {brandId}</p>
                            <p><strong>Модель:</strong> {model}</p>
                            <p><strong>Модель ID:</strong> {modelId}</p>
                            <p><strong>Год выпуска:</strong> {year}</p>
                            <p><strong>Год выпуска ID:</strong> {yearId}</p>
                            <p><strong>Цена:</strong> {price} UZS</p>
                        </div>
                        {renderInsuranceList()}
                    </>
                );
            case 1:
                return (
                    <>
                        {renderSummary()}
                        <h2>🚘 Данные авто</h2>
                        <input
                            type="text"
                            placeholder="Номер машины (например, 10A123AA)"
                            value={formData.carNumber}
                            onChange={e => setFormData({...formData, carNumber: e.target.value.toUpperCase()})}
                        />
                        <input
                            type="text"
                            placeholder="Серия и номер техпаспорта"
                            value={formData.techPassport}
                            onChange={e => setFormData({...formData, techPassport: e.target.value.toUpperCase()})}
                        />
                        <button className="continue-btn" onClick={handleNext}>Дальше</button>
                    </>
                );
            case 2:
                return (
                    <>
                        {renderSummary()}
                        <h2>👤 Паспортные данные владельца</h2>
                        <input
                            type="text"
                            maxLength={2}
                            placeholder="Серия паспорта (например, AB)"
                            value={formData.passportSeries}
                            onChange={e => {
                                const onlyLetters = e.target.value.toUpperCase().replace(/[^A-Z]/g, '');
                                setFormData({...formData, passportSeries: onlyLetters});
                            }}
                        />

                        <input
                            type="text"
                            placeholder="Номер паспорта (например, 1234567)"
                            value={formData.passportNumber}
                            onChange={e => setFormData({...formData, passportNumber: e.target.value})}
                        />
                        <input
                            type="text"
                            placeholder="Дата рождения (ДД.ММ.ГГГГ)"
                            value={formData.birthDate}
                            onChange={e => setFormData({...formData, birthDate: e.target.value})}
                        />
                        <button className="continue-btn" onClick={fetchPassportInfo}>Дальше</button>
                    </>
                );



            case 3:
                return (
                    <>
                        {renderSummary()}
                        <h2>📄 Информация по паспорту</h2>
                        {passportInfo ? (
                            <div className="passport-info-box">
                                <p><strong>Фамилия (ENG):</strong> {passportInfo.last_name_eng}</p>
                                <p><strong>Имя (ENG):</strong> {passportInfo.first_name_eng}</p>
                                <p><strong>Отчество:</strong> {passportInfo.middle_name}</p>
                                <p><strong>PINFL:</strong> {passportInfo.pinfl}</p>
                                <p><strong>Дата рождения:</strong> {passportInfo.birth_date}</p>
                                <p><strong>Адрес:</strong> {passportInfo.address}</p>
                                <p><strong>Пол:</strong> {passportInfo.gender === '1' ? 'Мужской' : 'Женский'}</p>
                                <p><strong>Регион ID:</strong> {passportInfo.region_id}</p>
                                <p><strong>Район ID:</strong> {passportInfo.district_id}</p>
                            </div>
                        ) : (
                            <p>❗ Паспортные данные не найдены.</p>
                        )}
                        <h2>📞 Заявитель</h2>
                        <input
                            type="text"
                            placeholder="Номер телефона"
                            value={formData.applicantPhone}
                            onChange={e => setFormData({...formData, applicantPhone: e.target.value})}
                        />
                        <button className="continue-btn" onClick={handleNext}>Готово</button>
                    </>
                );

            case 4:
                return (
                    <div className="thank-you">
                        {renderSummary()}
                        <h2>📄 Информация по паспорту</h2>
                        {passportInfo ? (
                            <div className="passport-info-box">
                                <p><strong>Фамилия (ENG):</strong> {passportInfo.last_name_eng}</p>
                                <p><strong>Имя (ENG):</strong> {passportInfo.first_name_eng}</p>
                                <p><strong>Отчество:</strong> {passportInfo.middle_name}</p>
                                <p><strong>PINFL:</strong> {passportInfo.pinfl}</p>
                                <p><strong>Дата рождения:</strong> {passportInfo.birth_date}</p>
                                <p><strong>Адрес:</strong> {passportInfo.address}</p>
                                <p><strong>Пол:</strong> {passportInfo.gender === '1' ? 'Мужской' : 'Женский'}</p>
                                <p><strong>Регион ID:</strong> {passportInfo.region_id}</p>
                                <p><strong>Район ID:</strong> {passportInfo.district_id}</p>
                            </div>
                        ) : (
                            <p>❗ Паспортные данные не найдены.</p>
                        )}
                        <h2>✅ Спасибо!</h2>
                        <p>Все данные успешно заполнены.</p>
                        <button onClick={() => navigate('/')}>На главную</button>
                    </div>
                );
            default:
                return null;
        }
    };

    const renderStepsBar = () => {
        const steps = ['Инфо и страховка', 'Данные авто', 'Владелец авто', 'Заявитель', 'Готово'];
        return (
            <div className="steps">
                {steps.map((label, index) => (
                    <div key={label} className={`step ${index === step ? 'active' : ''}`}>
                        <span>{index}</span>
                        <p>{label}</p>
                    </div>
                ))}
            </div>
        );
    };

    const createUser = async () => {
        if (!passportInfo || !formData.applicantPhone) {
            console.warn('Нет данных для создания пользователя.');
            return;
        }

        const fullName = `${passportInfo.first_name_eng} ${passportInfo.last_name_eng} ${passportInfo.middle_name || ''}`.trim();

        const payload = {
            full_name: fullName,
            phone_number: formData.applicantPhone,
            passport_number: `${formData.passportSeries}${formData.passportNumber}`,
        };

        try {
            const response = await fetch('http://localhost:8081/api/users/create', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'User-Agent': 'insomnia/11.1.0',
                },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                throw new Error('❌ Ошибка при создании пользователя');
            }

            const userId = await response.json(); // Получаем число из ответа

            const timestamp = new Date().toISOString(); // или new Date().toLocaleString()

            // Сохраняем в localStorage
            localStorage.setItem('userId_createdAt', timestamp);

            console.log('✅ Пользователь создан. ID:', userId);
        } catch (error) {
            console.error('Ошибка создания пользователя:', error);
        }
    };


    return (
        <div className="eosago-page">
            <main>
                {renderStepsBar()}
                <section className="data-block">
                    {renderStepContent()}
                    {step > 0 && step < 4 && (
                        <p className="agreement">
                            Нажимая «Продолжить», вы соглашаетесь с офертой и даёте согласие на обработку персональных
                            данных.
                        </p>
                    )}
                    {step > 0 && (
                        <button className="back-btn" onClick={handleBack}>
                            ← Назад
                        </button>
                    )}
                </section>
            </main>

            {showOwnerMismatchModal && (
                <div className="modal-overlay">
                    <div className="modal">
                        <h3>⚠️ Внимание</h3>
                        <p>Владелец автомобиля не совпадает с введённым паспортом.</p>
                        <p>Продолжить оформление страховки?</p>
                        <div className="modal-buttons">
                            <button onClick={() => {
                                setShowOwnerMismatchModal(false);
                                setStep(prev => prev + 1);
                            }}>Продолжить</button>
                            <button onClick={() => navigate('/')}>Отмена</button>
                        </div>
                    </div>
                </div>
            )}


            {showModal && (
                <div className="modal-overlay">
                    <div className="modal">
                        <h3>Введите код подтверждения</h3>
                        <p>Мы отправили SMS на номер {formData.applicantPhone}</p>
                        <input
                            type="text"
                            placeholder="Введите код (например, 123)"
                            value={confirmationCode}
                            onChange={e => setConfirmationCode(e.target.value)}
                        />
                        <button onClick={handleConfirmCode}>Подтвердить</button>
                        <button onClick={() => setShowModal(false)}>Отмена</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CarsInfoPageBlock;
